export function sanitizeFilename(title, fallback = "untitled") {
    const cleaned = title
        .replace(/[<>:"/\\|?*\x00-\x1f]/g, "")
        .replace(/\s+/g, "-")
        .replace(/^[.\-]+|[.\-]+$/g, "")
        .slice(0, 80)
        .trim();
    return cleaned.length > 0 ? cleaned : fallback;
}
export function downloadText(filename, text, mime = "text/markdown;charset=utf-8") {
    const blob = new Blob([text], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
/**
 * Download a JS value as a pretty-printed UTF-8 JSON file.
 *
 * The content is prefixed with a UTF-8 BOM (U+FEFF) and the blob is tagged
 * `application/json;charset=utf-8` so file-preview tools (notably iOS/mobile
 * Quick Look) render non-Latin scripts like Hebrew correctly instead of as
 * mojibake (e.g. "×©×™"). Importers must strip a leading BOM before
 * `JSON.parse` — see `listImport`.
 */
export function downloadJsonFile(data, filename) {
    const json = JSON.stringify(data, null, 2);
    const blob = new Blob(["\uFEFF" + json], {
        type: "application/json;charset=utf-8",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
// Bundle multiple text entries into a single .zip download. Filename
// collisions are de-duplicated by appending `-1`, `-2`, … before the
// extension so a selection of READMEs with the same title still produces
// a usable archive.
export async function downloadZip(filename, entries) {
    // Dynamic import keeps JSZip out of the initial bundle for users who never
    // trigger a bulk download.
    const { default: JSZip } = await import("jszip");
    const zip = new JSZip();
    const used = new Set();
    for (const entry of entries) {
        let name = entry.name;
        if (used.has(name)) {
            const dot = name.lastIndexOf(".");
            const base = dot >= 0 ? name.slice(0, dot) : name;
            const ext = dot >= 0 ? name.slice(dot) : "";
            let i = 1;
            while (used.has(`${base}-${i}${ext}`))
                i++;
            name = `${base}-${i}${ext}`;
        }
        used.add(name);
        zip.file(name, entry.content);
    }
    const blob = await zip.generateAsync({ type: "blob" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
